import { MdPerson, MdEmail, MdLock, MdDriveEta, MdColorLens, MdDirectionsCar, MdPhoneIphone } from 'react-icons/md';

const icons = {
  UserIcon: MdPerson,
  EmailIcon: MdEmail,
  LockIcon: MdLock,
  DriveEtaIcon: MdDriveEta,
  ColorLensIcon: MdColorLens,
  DirectionsCarIcon: MdDirectionsCar,
  PhoneIphoneIcon: MdPhoneIphone
};

export default icons;

